import capitalize from "@mui/material/utils/capitalize";

export const withTransaction = (filter: string) =>
    `transaction${capitalize(filter)}`;
